export default "__VITE_ASSET__Cur1ZBep__"